import { render, staticRenderFns } from "./YzTooltip.vue?vue&type=template&id=2a1b287c&scoped=true&lang=pug&"
import script from "./YzTooltip.vue?vue&type=script&lang=js&"
export * from "./YzTooltip.vue?vue&type=script&lang=js&"
import style0 from "./YzTooltip.vue?vue&type=style&index=0&id=2a1b287c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a1b287c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VTooltip})
